import { Link } from "react-router";
import { Button } from "@/components/ui/button/Button";
import { Text } from "@/components/ui/text/Text";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="space-y-6 max-w-md">
        <div className="space-y-2">
          <h1 className="text-8xl font-bold text-slate-200 dark:text-slate-700 select-none">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">
            Page not found
          </h2>
          <Text>
            Sorry, we couldn&apos;t find the page you&apos;re looking for. It
            might have been moved, deleted, or the URL might be incorrect.
          </Text>
        </div>

        <div className="flex justify-center gap-4">
          <Button
            href="/"
            color="indigo"
            icon={<FontAwesomeIcon icon={faHome} />}
          >
            Go back home
          </Button>
        </div>
      </div>
    </div>
  );
}
